export const FEATURE_FLAG_KEYS = [
    "contracts",
    "send_intelelead_invites",
    "send_insurance_toolkit_agents",
    "submit_pinnacle_contracts",
    "submit_reagan_contracts",
    "send_carrier_direct_invites",
    "disable_outbound_emails",
    "create_surelc_producers",
    "simulate_surelc",
    "require_surelc_proceed",
];
export const FEATURE_FLAG_DEFINITIONS = {
    contracts: {
        key: "contracts",
        label: "Contracts",
        description: "Show the agent portal Contracts section, navigation, and apply flow.",
        defaultEnabled: true,
    },
    send_intelelead_invites: {
        key: "send_intelelead_invites",
        label: "Actually Send Intelelead Invites",
        description: "When ON, Dialer fulfillment clicks Send in the Intelelead invite modal for real. When OFF (default), it still logs in, opens the invite modal, and fills every field, but stops short of clicking Send — a dry run so nothing real goes out. The task reports as failed (needs attention) whenever no invite was actually sent.",
        defaultEnabled: false,
    },
    send_insurance_toolkit_agents: {
        key: "send_insurance_toolkit_agents",
        label: "Actually Add Insurance Toolkit Agents",
        description: "When ON, Insurance Toolkit fulfillment clicks Add Agent for real — this creates a paid seat billed at $29.99/mo. When OFF (default), it still logs in, opens the Add Agent modal, and fills every field, but stops short of clicking Add Agent — a dry run so no seat is created and nothing is charged. The task reports as failed (needs attention) whenever no agent was actually added.",
        defaultEnabled: false,
    },
    submit_pinnacle_contracts: {
        key: "submit_pinnacle_contracts",
        label: "Actually Submit Pinnacle Contracts",
        description: "When ON, Pinnacle contracting clicks Submit on the pfsinsurance.com/spot form for real. When OFF (default), it still opens the form and fills every field — carriers, states, W9 and EFT uploads, signature — but stops short of clicking Submit, a dry run so no contract request reaches Pinnacle. Screenshots of the filled form are saved to Run Artifacts either way. The submission reports as failed (needs attention) whenever nothing was actually submitted.",
        defaultEnabled: false,
    },
    submit_reagan_contracts: {
        key: "submit_reagan_contracts",
        label: "Actually Submit Reagan Contracts",
        description: "When ON, Heartland contracting clicks Send in ReaganAI for real. When OFF (default), it still logs in, opens the contract request, and fills every field including commission levels, but stops short of clicking Send — a dry run so nothing real goes out. Screenshots of each step are saved to Run Artifacts either way. The submission reports as failed (needs attention) whenever nothing was actually sent.",
        defaultEnabled: false,
    },
    send_carrier_direct_invites: {
        key: "send_carrier_direct_invites",
        label: "Actually Send Aflac / American Home Life Invites",
        description: "When ON, the direct-carrier bot sends the agent's invite from Altura's Aflac or American Home Life portal login for real. When OFF (default), it logs in and screenshots each screen to Run Artifacts but sends nothing. The invite screens are not mapped yet, so the run stops before the invite either way until they are.",
        defaultEnabled: false,
    },
    disable_outbound_emails: {
        key: "disable_outbound_emails",
        label: "Disable Outbound Emails (Testing)",
        description: "When ON, all outbound emails (magic links, submission confirmations, upline/PPG notifications, draft-resume nudges, etc.) are skipped and logged instead of sent via Resend — use while testing so real emails don't go out. When OFF (default), emails send normally.",
        defaultEnabled: false,
    },
    create_surelc_producers: {
        key: "create_surelc_producers",
        label: "Create SureLC Producers",
        description: "When ON, submitting an application creates the agent in SureLC (PUT /producers/). Each new producer is a $1.25 NIPR entry. When OFF (default), the job still builds and validates the payload and records a dry run, but never calls SureLC to create the producer.",
        defaultEnabled: false,
    },
    simulate_surelc: {
        key: "simulate_surelc",
        label: "Simulate SureLC (Testing)",
        description: "When ON, new SureLC producer requests never reach SureLC. The worker skips the NIPR lookup and the $1.25 create, makes a simulated producer whose id starts with SIM-, and each sync reports made-up progress for it: EFT, E&O, and AML on file, then a carrier request that is started, submitted, at the carrier, and completed over about 30 minutes. Simulated agents cannot open real SureLC. Takes priority over Create SureLC Producers. Turn it off before real agents contract; simulated producers already made stay simulated.",
        defaultEnabled: false,
    },
    require_surelc_proceed: {
        key: "require_surelc_proceed",
        label: "Require SureLC Proceed Before Dialer Setup",
        description: "When ON, agents on the SureLC path must have at least one carrier request submitted inside SureLC and click Proceed before Dialer Setup, training, and the setup forms unlock. Agents who contracted before SureLC keep the old rule (any contract). When OFF (default), any contract on Altura unlocks Dialer Setup. Turn on once live SureLC producer creation and single sign-on are working, or SureLC agents will have no way to Proceed.",
        defaultEnabled: false,
    },
};
export function isFeatureFlagKey(value) {
    return typeof value === "string" && FEATURE_FLAG_KEYS.includes(value);
}
